var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThrobber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C7.13875 16 6.30123 15.8664 5.49894 15.6017C4.97473 15.4288 4.76369 14.8258 5.00023 14.3271C5.23698 13.8279 5.83269 13.6248 6.36429 13.7753C6.89207 13.9247 7.43924 14 8 14C11.309 14 14 11.309 14 8C14 4.691 11.309 2 8 2C4.691 2 2 4.691 2 8C2 8.56164 2.07538 9.10929 2.22518 9.63739C2.37589 10.1687 2.17353 10.7644 1.6748 11.0016C1.17623 11.2387 0.572971 11.0281 0.399708 10.5039C0.134225 9.70067 0 8.86221 0 8C0 3.589 3.589 0 8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16Z",
    fill: "#96B000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrobber2);
export default __webpack_public_path__ + "static/media/throbber2.4394f1dc7a044bde59ccf3af5e3bb983.svg";
export { ForwardRef as ReactComponent };